import { FThemeDefaultGraphicViewer } from "./f-theme-default-graphic-viewer";

export class FThemeDefaultEnUsGraphicViewer extends FThemeDefaultGraphicViewer {}
